module.exports = __webpack_public_path__ + "static/media/point-icon.0e45d64f.svg";